import axios from 'axios';
export function createTurnRepository(config) {
    const { repository, client } = config;
    const PREFIX = ['turnCredentials']; // Unique query key prefix
    // Helper function to generate consistent query keys
    const getQueryKey = (context) => [
        ...PREFIX,
        context.principal?.id, // Include user ID for potential future caching separation
    ];
    return {
        useLookup(context, props, options) {
            const baseQueryKey = getQueryKey(context); // ['turnCredentials', context.principal?.id]
            const query = repository.useQuery({
                queryKey: baseQueryKey, // Use the base key derived from context
                queryFn: async () => {
                    // Make a direct HTTP call to the TURN credentials endpoint
                    // Use the same base URL as the client and add the specific path
                    const response = await axios.get(`${client.config.baseUrl}/turn/credentials`, {
                        headers: {
                            Authorization: `Bearer ${context.token}`,
                            'x-workspace-id': context.workspace.id,
                        },
                    });
                    return response.data;
                },
                ...options, // Spread other options last
            });
            return query;
        },
    };
}
//# sourceMappingURL=turnRepository.js.map